import {
  DisplayTaxRate,
  FormTaxRate,
  WorkOrderTaxOverrideFormValues,
  WorkOrderTaxOverrideModifyData
} from '~/work_order/tax-overrides/types'
import { FilteredEffectiveDatedFields } from '~/work_order/modify_work_order/PageDataProvider'

export function toFormData(taxOverrideData: FilteredEffectiveDatedFields[]): WorkOrderTaxOverrideFormValues[] {
  const convertRateToForm = (rate: DisplayTaxRate): FormTaxRate => ({
    [rate.tax_type_code]: rate.rate ?? '0'
  })

  return taxOverrideData
    .filter(taxO => taxO.tax_override?.display)
    .map(taxO => {
      const { tax_rates, ...rest } = taxO.tax_override!.raw_form_value
      return {
        start_date: taxO.start_date,
        end_date: taxO.end_date,
        tax_rates: (tax_rates || []).map(convertRateToForm).reduce((acc: any, rate: any) => ({ ...acc, ...rate }), {}),
        ...rest
      }
    })
}

export function toChangeSetData(formOverride: WorkOrderTaxOverrideFormValues): WorkOrderTaxOverrideModifyData {
  return {
    tax_behavior: formOverride.tax_behavior,
    tax_location: formOverride.tax_location,
    manual_tax_country_code: formOverride.manual_tax_country_code,
    manual_tax_subdivision_code: formOverride.manual_tax_subdivision_code,
    tax_rates: Object.entries(formOverride.tax_rates || {}).map(([tax_type_code, rate]) => ({
      tax_type_code,
      rate
    }))
  }
}
